export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10537.d449d45d.jpg";